<template>
  <div class="section">
    <div class="container">
      <h1 style="line-height: 1em">
        AWG's ASU assessment -- as to whether countries meet the substantive standard set out in the ASU
      </h1>
      <p>ASU means the OECD's Aircraft Sector Understanding on Export Credits
        for Civil Aircraft for eligibility for the CTC discount.</p>
      <p>
        AWG assesses whether countries meet the substantive standards set out in the ASU for eligibility for the Cape Town Convention discount as set out in the 2011 ASU (CTC discount).
      </p>
      <!-- <div class="has-text-centered my-6">
				<a
					class="button is-primary"
					href="/AWG's ASU assessment for eligibility for CTC discount.pdf">
					Download the ASU assessment
				</a>
			</div> -->
      <p style="border: solid 1px red; padding: 10px">
        The AWG assessment is independent of the OECD (and its participants) and
        their decision-making on eligibility for the CTC discount under the ASU. It
        assesses the substantive ASU standard without reference to whether a
        country is on the 'Cape Town list', as defined in the ASU.
      </p>
      <p>
        AWG has prepared an
        <a target="_blank" href="/AWG's ASU assessment for eligibility for CTC discount - latest - website annex.pdf">
          explanation and methodology
        </a>
        for this assessment.
      </p>
      <p>The basic framework for that methodology is as follows:</p>
      <p>
      <ul style="list-style: disc; margin: 0 30px;">
        <li>Eligibility for the CTC discount requires satisfaction of the three
          conditions below: conditions 1 (making of the ASU 'qualifying
          declarations'), condition 2 (compliant implementation: primacy
          and completeness), and condition 3 (compliant precedent and
          experience: judicial and administrative).</li>
        <li>As the making of the qualifying declarations is a threshold
          requirement for meeting the substantive standard for the CTC
          discount, where condition 1 has not been satisfied (qualifying
          declarations have not been made), scoring on conditions 2 and
          3 (compliant implementation and precedent and experience,
          respectively) have not been provided. To see such scores, see
          full compliance index.</li>
        <li>
          Where there is insufficient legal analysis to reach a sound view
          on conditions 2 and 3 (compliant implementation and precedent
          and experience, respectively), scoring on such conditions have
          not been provided (and is not available on the full compliance
          index).
        </li>
      </ul>

      </p>

      <div class="level-right mb-4">
        <div class="level-item">
          <a href="javascript://" @click="Export">
            <span>
              <i class="fad fa-download"></i>
              &nbsp;Download Excel
            </span>
          </a>
          &nbsp;
          <div v-show="printing">
            <i class="far fa-spinner-third fa-spin"></i>
          </div>
        </div>
      </div>
      <div id="xlsx_top">
        <div style="border: solid 1px red; padding: 4px; margin-bottom: 4px" class="hidden-on-pageview">
          <p>
            This AWG assessment is independent of the OECD (and its participants) and their
            decision-making on eligibility for the Cape Town Convention discount under the ASU. It
            assesses the substantive ASU standard without reference to whether a country is on the
            ‘Cape Town list’, as defined in the ASU.
          </p>
          <p>
            Eligibility for the CTC discount requires satisfaction of the three conditions below:
            conditions 1 (making of the ASU ‘qualifying declarations’), condition 2 (compliant
            implementation: primacy and completeness), and condition 3 (compliant precedent and
            experience: judicial and administrative).
          </p>
          <p>
            As the making of the qualifying declarations is a threshold requirement for meeting the
            substantive standard for the CTC discount, where condition 1 has not been satisfied
            (qualifying declarations have not been made), scoring on conditions 2 and 3 (compliant
            implementation and precedent and experience, respectively) have not been provided. To
            see such scores, see full compliance index.
          </p>
          <p>
            Where there is insufficient legal analysis to reach a sound view on conditions 2 and 3
            (compliant implementation and precedent and experience, respectively), scoring on such
            conditions have not been provided (and is not available on the full compliance index).
          </p>
        </div>
        <div style="border: solid 1px red; padding: 4px" class="hidden-on-pageview">
          <p>
            See generally the
            <a href="http://awg.aero/wp-content/uploads/2022/12/AWGs-ASU-assessment-for-eligibility-for-CTC-discount-latest-explanation-and-methodology-website-annex.pdf">
              annexed
            </a>
            <b>Explanation and Methodology</b>
            . It (a) addresses the assessment of conditions 2 and 3 (compliant implementation and
            precedent and experience, respectively), and (b) describes the data and analytic process
            relating to scoring.
          </p>
        </div>
      </div>
      <div id="asu-table">
        <b-table :data="groups" mobile-cards :default-sort="['Group', 'asc']">
          <b-table-column field="Group" label="Country" sortable v-slot="props">
            <img class="flag-small" :src="getFlag(props.row.LogoPath)" />
            <router-link :to="{ name: 'complianceIndex', params: { GroupId: props.row.GroupId } }">
              {{ props.row.Group }}
            </router-link>
          </b-table-column>
          <b-table-column field="Watchlist" width="30" sortable v-slot="props">
            <a id="watchlist-index" style="border: none" href="javascript://" @click="goToCountryIndexNotices(props.row.GroupId)" v-show="props.row.Watchlist && CanSeeWatchList(props.row.GroupId)">
              <i class="fad fa-exclamation-triangle" v-tooltip="Tooltip($watchlist)"></i>
            </a>
          </b-table-column>
          <b-table-column field="ASU" label="Conclusion" sortable v-slot="props">
            <span v-if="props.row.Suspended">Suspended</span>
            <span v-else>{{ props.row.ASU }}</span>
          </b-table-column>
          <b-table-column field="QualifyingDeclarations" label="Condition 1" sortable v-slot="props">
            <span v-if="props.row.QualifyingDeclarations">Yes</span>
            <span v-else>No</span>
          </b-table-column>
          <b-table-column field="A" label="Condition 2" sortable v-slot="props">
            <span v-if="!props.row.A && props.row.A != 0">-</span>
            <span v-else-if="props.row.A >= 4">Yes</span>
            <span v-else>No</span>
          </b-table-column>
          <b-table-column field="B" label="Condition 3" sortable v-slot="props">
            <span v-if="!props.row.B && props.row.B != 0">-</span>
            <span v-else-if="props.row.B >= 3">Yes</span>
            <span v-else>No</span>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import Role from "@/roles";

export default {
  data() {
    return {
      loading: true,
      groups: [],
      printing: false
    };
  },
  methods: {
    getFlag(path) {
      if (!path) return;
      return require("@/assets/images/countryLogos/" + path);
    },
    async Export() {
      this.printing = true;

      //let html = document.getElementById("xlsx_document").innerHTML;
      //let html = document.getElementById("asu-table").innerHTML;

      let xlsx_top_children = document.getElementById("xlsx_top").children;
      let newthead = document.createElement("thead");
      let newtr = document.createElement("tr");
      let newth = document.createElement("th");
      newth.colSpan = 5;
      newth.style.border = "solid 1px red";
      newth.style.overflow = "scroll";
      newth.style.height = "6px";
      newth.style.fontFamily = "Arial";
      newth.style.fontSize = "13pt";
      newth.append(xlsx_top_children[0]);
      newtr.append(newth);
      newthead.append(newtr);
      newtr = document.createElement("tr");
      newth = document.createElement("th");
      newth.colSpan = 5;
      newth.style.border = "solid 1px red";
      newth.style.overflow = "scroll";
      newth.style.height = "6px";
      newth.style.fontFamily = "Arial";
      newth.style.fontSize = "13pt";
      newth.append(xlsx_top_children[0]);
      newtr.append(newth);
      newthead.append(newtr);

      let tableDOM = document.getElementById("asu-table").cloneNode(true); // as Element;
      let table = tableDOM.getElementsByTagName("table")[0];
      table.style.lineHeight = "2";
      let thead = tableDOM.getElementsByTagName("thead")[0];
      let tr = thead.getElementsByTagName("tr")[0];
      tr.style.height = "0px";
      thead.style.height = "0px";
      table.insertBefore(newthead, thead);
      console.log(tableDOM.innerHTML);
      let html = tableDOM.innerHTML;

      const filename = "ASU_assessment" + new Date().toLocaleDateString() + ".xlsx";
      try {
        var response = await this.$http.post(
          "api/print/asu",
          { html: html },
          {
            responseType: "blob"
          }
        );

        const blob = response.data;
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
      this.printing = false;
    },
    async GetGroups() {
      try {
        var response = await this.$http.get("api/group/index/list");
        this.groups = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    HighlightBG(row, index) {
      switch (row.Category) {
        case "Very High": {
          return "is-vhigh-category";
        }
        case "High": {
          return "is-high-category";
        }
        case "Medium": {
          return "is-medium-category";
        }
        case "Low": {
          if (row.Score > 0) {
            return "is-low-category";
          } else {
            return "is-no-score";
          }
        }
      }
    },
    Tooltip(content) {
      return {
        autoHide: false,
        html: true,
        content: content
      };
    },
    CanSeeWatchList(id) {
      var user = this.$store.getters.user;
      if (user) {
        if (
          user.Roles.some(
            (r) =>
              r == Role.Admin ||
              r == Role.Enhanced ||
              r == Role.Standard ||
              r == Role.AWGMember ||
              r == Role.CountryViewer
          )
        ) {
          return true;
        } else if (
          user.Roles.some((r) => r == "CountryRespondent" && user.Groups.some((g) => g == id))
        ) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    goToCountryIndexNotices(id) {
      if (id == "a70fc607-1f3b-4957-8734-134da9cdfda0") {
        this.$router.push("/index/" + id + "#notices");
      } else if (
        (this.$store.getters.user &&
          this.$store.getters.user.Groups &&
          this.$store.getters.user.Groups.some((r) => r == id)) ||
        (this.$store.getters.user &&
          this.$store.getters.user.Roles &&
          this.$store.getters.user.Roles.some(
            (r) =>
              r == Role.Admin || r == Role.Enhanced || r == Role.Standard || r == Role.AWGMember
          ))
      ) {
        this.$router.push("/index/" + id + "#notices");
      } else {
        this.$router.push("/restricted");
      }
    }
  },
  mounted() {
    this.GetGroups();
  }
};
</script>

<style>
.hidden-on-pageview {
  display: none;
}
</style>
